import { Skeleton } from '@/shared/components/shadcn'

export function FarmWidgetSkeleton() {
  return (
    <div className="p-6 border rounded-xl shadow-sm flex flex-col space-y-6 no-underline">
      <div className="flex justify-between items-start">
        <div className="flex flex-col md:flex-row md:items-center space-x-3 gap-y-3">
          <Skeleton className="h-16 w-16 rounded-full" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-3 w-48" />
          </div>
        </div>
        <Skeleton className="h-6 w-6 md:w-16" />
      </div>
      <div className="flex justify-between">
        <div className="hidden md:flex items-center space-x-2 flex-wrap text-sm">
          <Skeleton className="h-4 w-6" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-28" />
        </div>
        <div className="flex items-center space-x-2 flex-wrap text-sm">
          <Skeleton className="h-4 w-6" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-28" />
        </div>
      </div>
      <div className="flex flex-col justify-between flex-wrap space-y-3">
        <div className="space-y-3">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-2.5 rounded" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-2.5 w-3/4 rounded" />
          </div>
        </div>
        <div className="space-y-3">
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-2.5 w-full rounded" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-2.5 w-3/4 rounded" />
          </div>
        </div>
      </div>

      <div className="pt-3 flex flex-wrap gap-2 text-sm">
        <div className="space-y-1">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-4 w-20" />
        </div>
        <div className="space-y-1">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-4 w-14 md:w-24" />
        </div>
      </div>
    </div>
  )
}
